import { EditText } from '../../../../../component/ui/edit-text/edit-text';
import CallToActionButton from '../../../../../component/call-to-action-button/call-to-action-button';
import React, { useState } from 'react';
import { addNewServicePaymentTypeOperations } from '../operations/add-new-service-payment-type-operations';

interface DialogAddNewServicePaymentTypeModel {
  closeDialog: (shouldRefresh?: boolean) => void;
}

export const DialogAddNewServicePaymentType: React.FC<
  DialogAddNewServicePaymentTypeModel
> = ({ closeDialog }) => {
  const [serviceType, setServiceType] = useState('');
  const [loading, setLoading] = useState(false);
  const handleOnSubmit = async () => {
    await addNewServicePaymentTypeOperations(serviceType, setLoading, () =>
      closeDialog(true),
    );
  };

  return (
    <div>
      <EditText title={'הזן שם סוג שרות תשלום'} onChange={setServiceType} />
      <div style={{ height: '8px' }} />
      <CallToActionButton
        text={'אישור'}
        onClick={handleOnSubmit}
        loading={loading}
      />
    </div>
  );
};
